import React, { useState, useEffect, useRef } from "react";
import './GameInfoBox.css'

function GameInfoBox({title, images4urls, platform, description, downloadUrl}) {
    return(
        <div className="gamebox">
            {/* <div className="gameboxTitleBackgroundColor"></div> */}
            <div className="gameboxTitleBackgroundColor">{title}</div>
            <div className="innerGamebox">
            {/* <div className="gameboxTitleBackgroundColor">{title}</div> */}
            <div className="images">
                {images4urls.map((url, index) => {
                    return <a className="imageLink" key={index} href={`imgs/fullSize/${title}/${index + 1}.jpg`} target="_blank">
                        <img className="subimage" src={`imgs/thumbnails/${title}/${index + 1}.jpg`}/>
                    </a>
                })}
            </div>
            {/* {platform === 'VR' ? <div/> : platform === 'Android' ? <dic/> : null} */}
            <div style={{marginBottom: '5%'}}>{description}</div>
                <a href={downloadUrl} target="_blank">{'Download from ' + (platform === 'VR' ? 'Oculus Store': platform === 'Android' ? 'Google Play' : 'Download')}</a>
            </div>
        </div>
    )
}

export default GameInfoBox;